import { render, staticRenderFns } from "./InternalKeywords.vue?vue&type=template&id=1c6dde13&"
import script from "./InternalKeywords.vue?vue&type=script&lang=js&"
export * from "./InternalKeywords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports